import { Link } from "react-router-dom";
import { MessageCircle, ShieldCheck } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { askMariUrl } from "../../lib/onboarding";

export const AskMari = ({ q, testid }) => (
  <Link to={askMariUrl(q)} className="inline-flex items-center gap-1.5 mt-3 font-mono text-[10px] tracking-wider text-brand hover:underline" data-testid={testid}>
    <MessageCircle className="w-3 h-3" /> ASK MARI ABOUT THIS
  </Link>
);

export const MetricTip = ({ children, title, body, q, testid }) => (
  <Popover>
    <PopoverTrigger asChild><button className="block w-full text-left cursor-help" data-testid={testid}>{children}</button></PopoverTrigger>
    <PopoverContent className="w-80 bg-black/95 border-white/15 backdrop-blur-xl" data-testid={`${testid}-tip`}>
      <p className="label-xs text-brand">{title}</p>
      <p className="text-sm text-white/75 mt-2">{body}</p>
      <AskMari q={q} testid={`${testid}-ask-mari`} />
    </PopoverContent>
  </Popover>
);

export const EvidenceBreakdown = ({ open, onOpenChange, ev }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-canvas border-white/15 max-w-lg" data-testid="evidence-breakdown-dialog">
      <DialogHeader><DialogTitle className="font-mono">Evidence collected: {ev.total} items</DialogTitle></DialogHeader>
      <ul className="grid grid-cols-2 gap-2 font-mono text-xs">
        {[["Integrity verified", `${ev.signed} SHA-256 hashed + HMAC signed`], ["Hash-chained", "each record links to the previous one"],
          ["Timestamp certified", `${ev.tsa_packages} of ${ev.packages} packages RFC 3161`], ["Ready for issuer", "sealed Merkle packages + PDF"]].map(([k, v]) => (
          <li key={k} className="border border-brand/25 bg-brand/[0.04] p-3"><p className="flex items-center gap-1.5 text-brand"><ShieldCheck className="w-3.5 h-3.5" />{k}</p><p className="text-white/55 mt-1 text-[10px]">{v}</p></li>
        ))}
      </ul>
      <p className="label-xs mt-2">Breakdown</p>
      <ul className="space-y-2" data-testid="evidence-breakdown-list">
        {ev.by_type.map((t) => (
          <li key={t.type} className="flex items-center gap-3 text-sm" data-testid={`evidence-type-${t.type}`}>
            <span className="font-mono w-12 text-right text-brand font-bold">{t.count}</span>
            <div className="flex-1 h-1.5 bg-white/5"><div className="h-full bg-brand/70" style={{ width: `${(100 * t.count) / ev.by_type[0].count}%` }} /></div>
            <span className="w-48 text-white/70">{t.label}</span>
          </li>
        ))}
      </ul>
      <Link to="/app/evidence" className="font-mono text-[10px] text-white/50 hover:text-brand mt-2" data-testid="evidence-breakdown-open-vault">OPEN EVIDENCE VAULT →</Link>
    </DialogContent>
  </Dialog>
);
